import { Body2, Box, Color, FontWeight, GridDisplay, Space } from '@gousto-internal/citrus-react'
import { type DashboardExperienceOrderDeliveryDetailsResponse } from '@library/api-dashboard-experience'
import React from 'react'

type ManageDeliveryPanelContentProps = {
  orderDeliveryDetails: DashboardExperienceOrderDeliveryDetailsResponse | undefined
}

export function ManageDeliveryPanelContent({
  orderDeliveryDetails,
}: ManageDeliveryPanelContentProps) {
  return (
    <Box
      display={GridDisplay.Grid}
      gridTemplateColumns={['1fr', '1fr', 'repeat(3, minmax(0, 1fr))']}
      gap={6}
    >
      <Box>
        <Body2 color={Color.ColdGrey_900} fontWeight={FontWeight.Bold}>
          Delivery date
        </Body2>
        <Space size={1} direction="vertical" />
        <Body2 color={Color.ColdGrey_800}>
          {orderDeliveryDetails?.delivery_date ?? 'Loading...'}
        </Body2>
      </Box>
      <Box>
        <Body2 color={Color.ColdGrey_900} fontWeight={FontWeight.Bold}>
          Delivery address
        </Body2>
        <Space size={1} direction="vertical" />
        {orderDeliveryDetails?.delivery_address ? (
          <>
            <Body2 color={Color.ColdGrey_800}>
              {orderDeliveryDetails.delivery_address.first_line}
            </Body2>
            <Body2 color={Color.ColdGrey_800}>
              {orderDeliveryDetails.delivery_address.second_line}
            </Body2>
            <Body2 color={Color.ColdGrey_800}>
              {orderDeliveryDetails.delivery_address.postcode}
            </Body2>
          </>
        ) : (
          <Body2 color={Color.ColdGrey_800}>Loading...</Body2>
        )}
      </Box>
      <Box>
        <Body2 color={Color.ColdGrey_900} fontWeight={FontWeight.Bold}>
          Box size
        </Body2>
        <Space size={1} direction="vertical" />
        <Body2 color={Color.ColdGrey_800}>{orderDeliveryDetails?.box_size ?? 'Loading...'}</Body2>
      </Box>
    </Box>
  )
}
